import { libraryTypeData, getVehicleHangarData, libraryBodyData } from '@blade-sxp/task-management/components/library-type/servies';
/**
 * 车辆库-策略
 */
class VehicleHangar {
    execute() {
        return getVehicleHangarData();
    }
}
/**
 * 人体库-策略
 */
class BodyBank {
    execute() {
        return libraryBodyData();
    }
}
/**
 * 人脸库-策略
 */
class FaceDatabase {
    execute() {
        return libraryTypeData();
    }
}
/**
 * 库工厂
 */
class WarehouseFactory {
    static libraryMap = new Map();
    static setLibraryType() {
        try {
            this.libraryMap.set('vehicle', new VehicleHangar());
            this.libraryMap.set('body', new BodyBank());
            this.libraryMap.set('face', new FaceDatabase());
        }
        catch (error) {
            throw new Error('setLibraryType error');
        }
    }
    static getLibraryType(type) {
        try {
            if (type) {
                return this.libraryMap.get(type);
            }
            else {
                throw new Error(type + 'getLibraryType get error');
            }
        }
        catch (error) {
            throw new Error('getLibraryType error');
        }
    }
}
export class Calculator {
    strategy;
    type;
    constructor(type) {
        this.type = type;
    }
    setStrategy(strategy) {
        this.strategy = strategy;
    }
    CalculatorResult() {
        return this.strategy.execute();
    }
}
export const libraryData = (type) => {
    const libraryMapHas = WarehouseFactory.libraryMap.has(type);
    if (!libraryMapHas) {
        WarehouseFactory.setLibraryType();
    }
    const calculator = new Calculator(type);
    calculator.setStrategy(WarehouseFactory.getLibraryType(type));
    return calculator.CalculatorResult();
};
